<section class="vc-admin-patients-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.PATIENTS.TITLE"
    descriptionKey="ADMIN.IA.PATIENTS.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="ADMIN.PATIENTS.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <p-select
      *ngIf="hasMultipleSites"
      toolbar-actions
      [options]="sites"
      [ngModel]="selectedMainSiteId"
      (ngModelChange)="onMainSiteFilterChange($event)"
      optionLabel="name"
      optionValue="id"
      [showClear]="true"
      [placeholder]="'COMMON.SITE' | translate"
      size="small"
      appendTo="body"
      styleClass="vc-admin-patients-list__site-filter"
    ></p-select>

    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-user-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'patients', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredPatients.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.PATIENTS.EMPTY.TITLE"
      descriptionKey="ADMIN.PATIENTS.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="filteredPatients"
      styleClass="Table"
      responsiveLayout="scroll"
      [autoLayout]="true"
      [paginator]="true"
      [first]="tableFirst"
      [rows]="tableRows"
      [rowsPerPageOptions]="[20, 40, 100]"
      (onPage)="onTablePage($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.NAME' | translate }}</th>
          <th>{{ 'COMMON.SURNAME' | translate }}</th>
          <th>{{ 'COMMON.EMAIL' | translate }}</th>
          <th>{{ 'COMMON.PHONE' | translate }}</th>
          <th *ngIf="hasMultipleSites">{{ 'COMMON.SITE' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-patient>
        <tr>
          <td>{{ patient.name }}</td>
          <td>{{ patient.surname }}</td>
          <td>{{ patient.email }}</td>
          <td>{{ patient.phone }}</td>
          <td *ngIf="hasMultipleSites">{{ patient.main_site_name || '-' }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'patients',
                patient.id,
                'profile'
              ]"
              [manageQueryParams]="listQueryParams"
              (delete)="confirmDelete(patient)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
